import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/guida-completa-itaobuy-spreadsheet/page";
import SicurezzaAcquisti from "@/pages/article/sicurezza-acquisti/page";
import QcPhotoGuida from "@/pages/article/qc-photo-guida/page";
import PagamentiSicuri from "@/pages/article/pagamenti-sicuri/page";
import ConfrontoAgent from "@/pages/article/confronto-agent/page";
import AnalisiPrezzi from "@/pages/article/analisi-prezzi/page";
import AlternativeItaobuy from "@/pages/article/alternative-itaobuy/page";
import StrategieItaobuy from "@/pages/article/strategie-itaobuy/page";
import RisparmioItaobuy from "@/pages/article/risparmio-itaobuy/page";
import OttimizzazioneOrdini from "@/pages/article/ottimizzazione-ordini/page";
import AuthorPage from "@/pages/author/page";
import AboutPage from "@/pages/about/page";
import PrivacyPolicy from "@/pages/privacy/page";
import CookiePolicy from "@/pages/cookie/page";
import DisclaimerPage from "@/pages/disclaimer/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/articoli/guida-completa-itaobuy-spreadsheet", element: <ArticlePage /> },
  { path: "/articoli/sicurezza-acquisti", element: <SicurezzaAcquisti /> },
  { path: "/articoli/qc-photo-guida", element: <QcPhotoGuida /> },
  { path: "/articoli/pagamenti-sicuri", element: <PagamentiSicuri /> },
  { path: "/articoli/confronto-agent", element: <ConfrontoAgent /> },
  { path: "/articoli/analisi-prezzi", element: <AnalisiPrezzi /> },
  { path: "/articoli/alternative-itaobuy", element: <AlternativeItaobuy /> },
  { path: "/articoli/strategie-itaobuy", element: <StrategieItaobuy /> },
  { path: "/articoli/risparmio-itaobuy", element: <RisparmioItaobuy /> },
  { path: "/articoli/ottimizzazione-ordini", element: <OttimizzazioneOrdini /> },
  { path: "/author", element: <AuthorPage /> },
  { path: "/about-itaobuy-spreadsheet", element: <AboutPage /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/cookie-policy", element: <CookiePolicy /> },
  { path: "/disclaimer", element: <DisclaimerPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;